import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { Card, CommitteeHeader } from "@components/common/card";
import MemberImage from "@components/parliament/member-image";
import type { DebateListEntry } from "@lib/api/debates/types";
import { routes } from "@lib/navigation";
interface Props {
  debate: DebateListEntry;
}
export default function DebateCard(t0) {
  const $ = _c(25);
  const {
    debate
  } = t0;
  let t1;
  if ($[0] !== debate.id) {
    t1 = routes.debate(debate.id);
    $[0] = debate.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== debate.committee) {
    t2 = debate.committee && <CommitteeHeader committee={debate.committee} />;
    $[2] = debate.committee;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== debate.type) {
    t3 = <p className="text-xs text-slate-700 dark:text-slate-400 sm:text-sm">{debate.type}</p>;
    $[4] = debate.type;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== debate.title) {
    t4 = <p>{debate.title}</p>;
    $[6] = debate.title;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== debate.subtitle) {
    t5 = debate.subtitle && <p className="text-xs text-slate-700 dark:text-slate-400 sm:text-sm">{debate.subtitle}</p>;
    $[8] = debate.subtitle;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
    t6 = <div>{t3}{t4}{t5}</div>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== debate.sender) {
    t7 = debate.sender && <MemberImage imageUrl={debate.sender.imageUrl} firstName={debate.sender.firstName} lastName={debate.sender.lastName} party={debate.sender.party} sizes="(min-width: 640px) 96px, 80px" className="h-20 w-20 shrink-0 sm:h-24 sm:w-24" />;
    $[14] = debate.sender;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = <div className="flex justify-between gap-2 p-2">{t6}{t7}</div>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t2 || $[20] !== t8) {
    t9 = <Card className="p-0">{t2}{t8}</Card>;
    $[19] = t2;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t1 || $[23] !== t9) {
    t10 = <Link href={t1} prefetch={false}>{t9}</Link>;
    $[22] = t1;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
}